module.exports = __webpack_public_path__ + "static/media/brand.47d9028c.svg";